import Team from '@/store/models/Team'
import backend from '@/api/team'

export default {

  namespaced: true,

  state: {
    team: new Team(),
  },

  mutations: {
    ...Team.mutations(),
  },

  actions: {
    createTeam: ({state}) => new Promise((resolve, reject) => {
      const team = { ...state.team}
      team.apps = team.apps.map(app => app.id)
      backend.createTeam(team, ({data}) => {
        resolve(data)
      }, reject)
    }),
    loadTeam: ({commit}, teamId) => new Promise((resolve, reject) => {
      backend.loadTeam(teamId, ({data}) => {
        commit('setTeam', data)
        resolve(data)
      }, reject)
    }),
    updateMemberPermissions: ({commit, state}, payload) => new Promise((resolve, reject) => {
      backend.updateMemberPermissions({
        permissions: payload.values,
        member: payload.member.id,
        team: state.team.id
      }, resolve, reject)
    }),
    removeMember: ({commit}, member) => new Promise((resolve, reject) => {
      backend.removeTeamMember(member.id, () => {
        commit('removeMember', member)
        resolve()
      }, reject)
    })
  },

  getters: {
    team: state => state.team,
  }

}